import { envConfig } from 'config'
import { authentication } from 'utils'
import axiosInstance from 'utils/axiosConfig'

type DriverFeatureEligibilityResponse = {
    eligible: boolean
}

export const useDispatchService = () => {
    const serviceUrl = envConfig().REACT_APP_DISPATCH_SERVICE

    const getDriverFeatureEligibility = async (driverId: string, featureKey: string): Promise<boolean> => {
        const params = new URLSearchParams()
        params.append('driverId', driverId)
        params.append('featureKey', featureKey)

        const response = await axiosInstance.get<DriverFeatureEligibilityResponse>(
            `${serviceUrl}/DriverFeatureEnrollment/Eligibility?${params.toString()}`,
            { headers: await authentication.getAuthHeader('application/json') }
        )

        return response.data?.eligible === true
    }

    return {
        getDriverFeatureEligibility
    }
}
